import { apiGet } from "./helpers/api";
import { normalize, schema } from "normalizr";

const product = new schema.Entity("products");

export const fetchProducts = (dispatch, { userId }) => {
  dispatch({ type: "PRODUCTS_FETCH_REQUESTED" });

  return apiGet(`/api/v1/users/${userId}/products`).then((response) => {
    dispatch({
      type: "PRODUCTS_FETCHED",
      ...normalize(response.body.data, new schema.Array(product)),
    });
  }).catch((error) => {
    dispatch({ type: "PRODUCTS_FETCH_FAILED", error });
    throw error;
  });
};

export const fetchProduct = (dispatch, { userId, productId }) => {
  return apiGet(`/api/v1/users/${userId}/products/${productId}`).then((response) => {
    dispatch({
      type: "PRODUCT_FETCHED",
      ...normalize(response.body.data, product),
    });
  }).catch((error) => {
    dispatch({ type: "PRODUCT_FETCH_FAILED", error });
    throw error;
  });
};
